import { render, staticRenderFns } from "./RedeemPromotion.vue?vue&type=template&id=5dfe3180&scoped=true&lang=pug&"
import script from "./RedeemPromotion.vue?vue&type=script&lang=js&"
export * from "./RedeemPromotion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfe3180",
  null
  
)

export default component.exports